import TdTable from './TdTable';
import { Tooltip, IconButton } from '@material-tailwind/react';
import { PencilIcon } from '@heroicons/react/24/solid';
import { EditModalInputs } from '../Modal/EditModalInputs';
import { useState } from 'react';

const TrTableTd = ({ item, index, result, setNewPec }) => {
  const [modal, setModal] = useState(false);
  const handleModel = () => {
    setModal(!modal);
  };

  const isLast = index === result - 1;
  const classes = isLast ? 'p-4 ' : 'p-4 ';
  return (
    <tr className="dark:hover:bg-gray-600 border-b border-white">
      <TdTable classe={classes} first={true}>
        {item.produto}
      </TdTable>
      <TdTable classe={classes}>{item.quantidade}</TdTable>
      <TdTable classe={classes}>{item.produtoWinthor}</TdTable>
      <td className="p-2 ">
        <div className="flex items-center gap-2" onClick={handleModel}>
          <Tooltip content="Editar">
            <IconButton variant="text">
              <PencilIcon className="h-4 w-4" color="black" />
            </IconButton>
          </Tooltip>
        </div>
      </td>
      <EditModalInputs modal={modal} handleModal={handleModel} item={item} setNewPec={setNewPec} />
    </tr>
  );
};

export default TrTableTd;
